import React from 'react';

export default function TextInput({ type = 'text', label, value, onChange, ...rest }) {
  return <input type={type} value={value} onChange={(e) => onChange(e.target.value)} {...rest} />;
}
